<template>
  <div class="mod-config" style="height: 100%">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item style="float: left;" label="角色名称：">
        <el-input v-model="dataForm.params" placeholder="角色名称" clearable></el-input>
      </el-form-item>
      <el-button @click="search()" type="primary" icon="el-icon-search" style="float: left;"></el-button>
      <el-form-item style="float: right;">
        <el-button type="primary" @click="addOrUpdateHandle()" v-if="isAuth('role:add')">新增</el-button>
        <el-button type="danger" @click="deleteHandle()" :disabled="dataListSelections.length <= 0" v-if="isAuth('role:delete')">批量删除</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="dataList" border v-loading="dataListLoading" @selection-change="selectionChangeHandle"
      style="width: 100%;" height="calc(100% - 120px)" stripe :header-cell-style="{background:'#FAFAFA'}"
      placement="top">
      <el-table-column type="selection" header-align="center" align="center" width="50">
      </el-table-column>
      <el-table-column prop="roleId" header-align="center" align="center" label="ID" width="80">
      </el-table-column>
      <el-table-column prop="roleName" header-align="center" align="center" label="角色名称">
      </el-table-column>
      <el-table-column prop="remark" header-align="center" align="center" label="角色描述" show-overflow-tooltip>
      </el-table-column>
      <el-table-column v-if="isAuth('role:app')" prop="type" header-align="center" align="center" width="150"
        label="APP权限">
        <template slot-scope="scope">
          <label v-if="scope.row.type === 1">
            <i
              style="display: inline-block;width: 12px;height: 12px;border-radius: 10px;background: #00d67e;margin: 0 4px;"></i>启用
          </label>
          <label v-else>
            <i
              style="display: inline-block;width: 12px;height: 12px;border-radius: 10px;background: #767a81;margin: 0 4px;"></i>禁用
          </label>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" header-align="center" align="center" label="创建时间" width="180">
      </el-table-column>
      <el-table-column header-align="center" align="center" width="150" label="操作">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top">
            <el-button type="text" style="font-size: 18px;padding: 0;" @click="addOrUpdateHandle(scope.row.roleId)" v-if="isAuth('role:update')"><i
                class="el-icon-edit-outline"></i></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <el-button type="text" style="font-size: 18px;padding: 0;" @click="deleteHandle(scope.row.roleId)" v-if="isAuth('role:delete')"><i
                class="el-icon-delete"></i>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
      layout="prev, pager, next, jumper, total,sizes">
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
  </div>
</template>
<script>
import AddOrUpdate from './role-add-or-update'
import {isAuth} from '../../utils';

export default {
  data() {
    return {
      dataForm: {
        params: ''
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false
    }
  },
  components: {
    AddOrUpdate
  },
  created() {
    this.getDataList()
  },
  methods: {
    search(){
      this.pageIndex = 1;
      this.getDataList();
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      this.$http({
        url: this.$http.adornUrl('/role/list'),
        method: 'get',
        params: this.$http.adornParams({
          'pageNum': this.pageIndex,
          'pageSize': this.pageSize,
          'params': this.dataForm.params,
        })
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.dataList = data.data.rows
          this.totalPage = data.data.total
        } else {
          this.dataList = []
          this.totalPage = 0
          this.$message.error(data.msg)
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id)
      })
    },
    // 删除
    deleteHandle(id) {
      let ids = id ? [id] : this.dataListSelections.map(item => {
        return item.roleId
      })
      this.$confirm(`确定对[id=${ids.join(',')}]进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/role/delete'),
          method: 'post',
          data: this.$http.adornData(ids, false)
        }).then(({data}) => {
          if (data && data.code === 200) {
            this.getDataList()
            this.$message({
              message: data.msg,
              type: 'success',
              duration: 1000
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    //权限
    isAuth(key) {
      return isAuth(key)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/admincenter/role.vue